import { ActionContext } from "vuex"

export interface CartState {
  changeCount: number;
}

export default {
  namespaced: true,
  state: (): CartState => ({
    changeCount: 0,
  }),
  mutations: {
    change (state: CartState) {
      state.changeCount = state.changeCount + 1
    },
  },
  actions: {
    reset (context: ActionContext<CartState, {}>) {
      context.commit('change')
    },
    increment (context: ActionContext<CartState, {}>) {
      context.commit('change')
    },
    decrement (context: ActionContext<CartState, {}>) {
      context.commit('change')
    }
  }
}
